export default {
  SERVICE: {
    heading: 'Choose a service',
    subheading: 'Will we be providing a truck and equipment for your move? Or do you just need the muscle?',
    helper: null,
  },
  LOCATIONS: {
    heading: 'Enter addresses',
    subheading: 'Please search to find the correct address. Will you need help at an additional location?',
    helper: null,
  },
  PROPERTIES: {
    heading: 'Confirm the details for your locations.',
    subheading: 'Please adjust location details if necessary.',
    helper: '<span>If applicable, add the unit number below.</>',
  },
  INVENTORY: {
    heading: 'What items will we be moving?',
    subheading:
      'One of the last things I’ll need to know is what our pros will be moving. Walk me through room by room, starting in the kitchen.',
    helper: null,
  },
  SPECIAL_INVENTORY: {
    heading: 'Do you need help moving any of these items?',
    subheading: 'Detailed inventory helps us make sure we have the right people for the job.',
    helper: null,
  },
  DATE: {
    heading: 'Choose a preferred move date',
    subheading: null,
    helper: null,
  },
  TIME: {
    heading: 'What time would you like your move to begin?',
    subheading: null,
    helper: null,
  },
  HOURLY: {
    heading: 'Let us know what you need, we got you.',
    subheading: `For items weighing +200 lbs, please reserve 3 pros. For more details on heavy items, refer to our <a target='_blank' rel='noreferrer' href='/terms-of-service'>Terms of Service</a>.`,
    helper: null,
  },
  PACKAGE: {
    heading: 'Recommended plan for your move.',
    subheading: 'These are the services included in the package you selected.',
    helper: null,
  },
  FLEXIBILITY: {
    heading: null,
    subheading: 'Book today to ensure your move.',
    helper: null,
  },
  ADDONS: {
    heading: 'Do you need anything else?',
    subheading: 'You can add these any time after you reserve.',
    helper: null,
  },
  CHECKOUT: {
    heading: null,
    subheading: null,
    helper: null,
  },
  LDM_LEAD: {
    heading: `Looks like you're moving to another city.`,
    subheading:
      'We move thousands of families to a new city each year. Just enter your contact information, and a member of our concierge team will get in touch to build you a customized plan and get you a guaranteed quote for your move.',
    helper: null,
  },
  LDM_LEAD_CONFIRMATION: {
    heading: `Thanks. We'll be in touch soon.`,
    subheading: `Expect a call from our concierge team within one business day. We'll talk through your move details and then provide any available options.`,
    helper: null,
  },
  LEAD: {
    heading: `Looks like we don't service your location yet.`,
    subheading: 'Send us your contact info, and we will let you know when we can move you!',
    helper: '<span>Quick tip:</span> Fields with an <span>*</span> are required',
  },
  LEAD_CONFIRMATION: {
    heading: `Thanks. We'll be in touch soon.`,
    subheading: `Expect a call from our concierge team within one business day. We'll talk through your move details and then provide any available options.`,
    helper: null,
  },
  CONFIRMATION: {
    heading: 'Reservation booked!',
    subheading: null,
    helper: null,
  },
  PRIVACY_MODAL_BODY:
    'At Bellhop, privacy is a priority. During this call, we will collect your name, phone number, email address, physical address, payment information, and any other data you decide to share with us to set your move up for success. We use this information to provide the requested moving services, improve the customer experience, collect payment, and market products and services to you. Bellhop does not sell your information. You can review our privacy policy at www.getbellhop.com/privacy-policy. Do I have your consent to continue this call?',
};
